import { render, staticRenderFns } from "./ExchangeCoupons.vue?vue&type=template&id=96b67dca&scoped=true&"
import script from "./ExchangeCoupons.vue?vue&type=script&lang=js&"
export * from "./ExchangeCoupons.vue?vue&type=script&lang=js&"
import style0 from "./ExchangeCoupons.vue?vue&type=style&index=0&id=96b67dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b67dca",
  null
  
)

export default component.exports